exports.install = function (Vue, options) {
	//获取溯源列表
	Vue.prototype.getarchives = function(value={})
	{
		value.limitPage=this.$store.state.production.page;
		value.limitCount=this.$store.state.production.pagesize;
		value.m_qaeda_id=this.getCookie(this.config.jdid);
		return this.axiosget("/api/pt/archives/getList",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.$store.commit('archives',response.data.data);
			}
		})
	};
	//获取单条溯源信息
	Vue.prototype.gettrace = function(value)
	{
		return this.axiosget("/api/pt/archives/getArchives",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				if(response.data.data!=null)
				{
					this.$store.commit('trace',response.data.data);
				}
			}
		})
	};
	//物种结档
	Vue.prototype.archiveStartA = function(value)
	{
		return this.axiospost("/api/pt/archives/archiveStart",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getspecies();
			}
			return response;
		});
	};
}